export default "/images/storstroems_forsikring.avif?420d3c1ea62d36bf8c51cff9b1f75fe3";